<template>
  <div>
    <div class="teachersde">
      <div class="teachersde-one clearfix">
        <div class="teachersde-box-one">
          <img
            v-if="teacherInfo.pic1"
            :src="concatImageUrl(teacherInfo.pic1, 340, 500)"
            alt="王培山"
            style="width: 100%"
          />
        </div>
        <div class="teachersde-box-two">
          <div class="teachersde-text-one">
            <div>— — — {{ teacherInfo.tchName }}</div>
          </div>
          <div
            style="line-height: 30px"
            v-html="teacherInfo.achievement"
          ></div>
        </div>
      </div>
    </div>
    <div class="teachersde-two clearfix">
      <div class="am-text-center am-padding-lg">
        <img
          src="../../assets/images/teacher-t2.png"
          alt
        />
      </div>
      <div class="teachersde-view-one">
        <div
          class="teachersde-text-four"
          v-for="(item, index) in courseList"
          :key="index"
        >
          <div class="teachersde-text-pt">
            <img
              v-lazy="concatImageUrl(item.picFileName1, 300, 180)"
              :alt="item.courseName"
            />
			<div class="teachersde-text-five">
			  {{ item.courseName }}({{ item.specialName }})
			</div>
          </div>
		  
		  <div class="teachersde-text-product">
			  <div class="teachersde-text-product-wh">
				  <div style="margin: 0 0 20px 0;">
				   <div class="teachersde-text-product-wh-head-left">相关商品</div>
				   <a :href="'/product?k='+item.courseId" style="float: right;" v-if="item.products.length > 0">查看更多的</a>
				  </div>
				  <div style="width: 100%;height: 180px; clear: both;">
					  <template v-for="(pitem, key) in item.products">
						  <a class="teachersde-text-product-wh-head-img" :href="'/topic/course/'+pitem.productId">
							<div style="width: 170px;float: left;" > 
							   <img style="border-radius: 8px;"
								 v-lazy="concatImageUrl(pitem.image, 170, 100)"
								 :alt="pitem.name"
							   />
						   </div> 
						   <div style="width: calc(100% - 180px);float: right;">
							   <div style="height: 70px;" class="teachersde-text-product-wh-head-text">{{pitem.name}}</div>
							   <div class="teachersde-text-product-wh-head-text">
								   <div style="float: left;">{{pitem.specialName}}</div>
								   <div style="float: right;">
									   <span style="text-decoration: line-through;font-size: 14px;" v-if="pitem.marketPrice > pitem.reducedPrice">￥{{pitem.marketPrice}}</span>
									   <span style="font-size: 14px;padding-left: 5px;">￥</span>
									   <span style="font-size: 18px;">{{pitem.reducedPrice}}</span>
								   </div>
							   </div>
						   </div>					  
						  </a>
					  </template>
					  <template v-if="item.products.length < 1">
						  <div style="height: 180px;line-height: 100px;">
							  暂无相关商品～
						  </div>
					  </template>
				  </div>
				  
			  </div>
			  
			  <!-- 
			  <img
			    v-lazy="concatImageUrl(item.picFileName1, 300, 180)"
			    :alt="item.courseName"
			  />
			  -->
			  
		  </div>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { teacher } from "../../request";
export default {
  mixins: [siteMixin],
  data () {
    return {
      teacherInfo: {},
      courseList: [],
    };
  },
  mounted () {
    this.setMetaData("师资团队");
    this.getPageData();
  },
  methods: {
    getPageData () {
      const id = this.$route.params.id;
	  const agencyid = this.siteConfig.agencyId;
      if (!id) {
        this.$Message.error("参数错误");
      }
	  
      teacher.getTeacherInfo(id,agencyid).then((res) => {
        //console.log("newInfo", res);
        if (res.status === 1) {
          this.teacherInfo = res.data.teacher;
          this.courseList = res.data.courseList;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.teachersde {
  width: 100%;
  padding: 30px 0 0 0;
  /* height: 250px; */
  /* background: url(../img/we_bg.png) no-repeat top center; */
}
.teachersde-one {
  width: 1200px;
  /* height: 250px; */
  padding: 1px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 8px #eee;
}
.teachersde-box-one {
  width: 340px;
  height: 500px;
  float: left;
  background: #b9b7c4;
  margin: 30px 0 30px 45px;
  overflow: hidden;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 8px #eee;
}
.teachersde-box-one img {
  width: 100%;
  display: block;
}
.teachersde-box-two {
  padding: 32px 0px 32px 50px;
  width: 780px;
  float: left;
}
.teachersde-text-one {
  font-size: 24px;
  padding-top: 32px;
  color: #41a5fd;
  line-height: 60px;
}
.teachersde-text-one {
  font-size: 24px;
  padding-top: 32px;
  color: #41a5fd;
  line-height: 60px;
}
.teachersde-two {
  width: 1200px;
  margin: 20px auto;
}
.am-text-center {
  text-align: center !important;
}
.teachersde-view-one {
  width: 1200px;
  float: left;
  background: white;
  padding: 20px 0;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 8px #eee;
}

.teachersde-text-four {
  /* width: 300px; */
  /* float: left; */
  margin: 20px 49px;
  border-bottom: 1px solid #CCCCCC;
}
.teachersde-text-pt {
  width: 300px;
  height: 180px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  margin-bottom: 20px;
  display: inline-block;
}
.teachersde-text-product{
	height: 180px;
	overflow: hidden;
	position: relative;
	margin: 0 0 20px 20px;
	display: inline-block;
	border-left: 1px solid #cccccc;
	width: calc(100% - 320px);
}
.teachersde-text-product-wh{
	width: calc(100% - 20px);
	margin: 0 0 0 20px;
	display: inline-block;
}
.teachersde-text-product-wh-head-left{
	float: left;
	font-weight: 600;
	font-size: 18px;
}
.teachersde-text-product-wh-head-img{
	width: 50%;
	height:155px;
	display:inline-block;
	margin: 25px 0 0 0;
}
.teachersde-text-product-wh-head-text{
	padding-right: 15px;
	font-size: 16px;
	font-weight: 400;
}

.teachersde-text-five {
  line-height: 40px;
  width: 300px;
  font-size: 16px;
  text-align: center;
  position: absolute;
  bottom: 1px;
  color: #ffffff;
  background-color: #000000;
  opacity:0.8;
}
.teachersde-text-pt img {
  width: 100%;
  height: 180px;
  display: block;
}
.am-padding-lg {
  padding: 2.4rem;
}
</style>